import { Description, FilePresent, Image, VideoLibrary } from '@mui/icons-material'
import { dateFns } from '../constants'

export const maskDate = (v) => {
  let nv = v.replace(/\D/g, '')
  nv = nv.replace(/(\d{2})(\d)/, '$1/$2')
  nv = nv.replace(/(\d{2})(\d)/, '$1/$2')
  nv = nv.replace(/(\d{2})(\d{2})$/, '$1$2')
  nv = nv.slice(0, 10)
  return nv
}

export const capitalize = (value) => `${value.charAt(0).toUpperCase()}${value.slice(1)}`

export const prepareCurrentDateValue = ([startDate, endDate = dateFns.endOfDay(startDate)]) => [
  dateFns.startOfDay(startDate),
  endDate,
]

export const returnFieldColor = (CONSTANT, field = '') => {
  if (field) {
    if (field.length > CONSTANT) return '#dc3545'
    return '#9E9E9E'
  }
  return '#9E9E9E'
}

export const sanitizeBodyText = (text) => {
  return (text || '').replace(/\n{2,}/g, '\n\n').trimEnd()
}

/**
 * @param {string} text
 */
export const formByTextVariables = (text) => {
  if (!text) return []
  const regex = /{{\d{1,}}}/g
  return text.match(regex)
}

/**
 *
 * @param {Array} list
 * @param {Number} startIndex
 * @param {Number} endIndex
 * @returns {Array}
 */
export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

/*
 * @param {{index: number, value: string, buttons: object[]}} param
 * @returns boolean
 */
export const checkIfTextFieldsAreEqual = ({ btn, index, value, buttons = [] }) => {
  const lengthAction = buttons.filter((b) => b.type === 'CallToAction').length
  const lengthQuickly = buttons.filter((b) => b.type === 'QuickReply').length
  const indexOfFirstActionButton = buttons.findIndex((b) => b.type === 'CallToAction')
  const indexOfFirstQuicklyButton = buttons.findIndex((b) => b.type === 'QuickReply')

  let newIndex = index

  if (btn.type === 'CallToAction' && indexOfFirstQuicklyButton < indexOfFirstActionButton) newIndex += lengthQuickly
  if (btn.type === 'QuickReply' && indexOfFirstActionButton < indexOfFirstQuicklyButton) newIndex += lengthAction

  for (let i = 0; i < buttons.length; i += 1) {
    if (newIndex !== i && buttons[i].text.trim() === value.trim()) {
      return true
    }
  }
  return false
}

export const urlPattern =
  /((?:(?:http?|ftp)[s]*:\/\/)?[a-z0-9-%\/\&=?\.]+\.[a-z]{2,4}\/?([^\s<>\#%"\,\{\}\\|\\\^\[\]`]+)?)/gi

/**
 * @param {number} bytes
 * @param {number} decimals
 * @returns string
 */

export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`
}

/**
 *
 * @param {'MediaVideoId'| 'MediaImageId' | 'MediaDocumentId' | '*'} mediaType
 * @returns
 */
export const returnAcceptType = (mediaType) => {
  switch (mediaType) {
    case 'MediaVideoId':
      return '.mp4'
    case 'MediaImageId':
      return '.png,.jpeg,.jpg'
    case 'MediaDocumentId':
      return '.pdf'
    default:
      return '.png,.jpg,.jpeg,.pdf'
  }
}

/**
 *
 * @param {'pdf'| 'mp4' | '*'} type
 * @returns {number} size limit
 */
export const returnLimitSizeByType = (type) => {
  if (type === '*') return 5
  if (type.includes('pdf')) return 20
  if (type.includes('mp4')) return 16
  return 5
}

/**
 * @param {'MediaVideoId'| 'MediaImageId' | 'MediaDocumentId' | '*'} mediaType
 * @returns string
 */
export const returnCaption = (mediaType) => {
  let type = ''

  switch (mediaType) {
    case 'MediaVideoId':
      type = 'seu vídeo'
      break
    case 'MediaImageId':
      type = 'sua imagem'
      break
    case 'MediaDocumentId':
      type = 'seu documento'
      break
    default:
      type = 'seu arquivo'
      break
  }

  return `Arraste & Solte ${type} aqui`
}

/**
 *
 * @param {string} fileName
 * @returns string | null
 */
export const fileType = (fileName) => {
  if (!fileName) return null
  return fileName.substring(fileName.lastIndexOf('.') + 1 ?? 0, fileName.length) ?? fileName
}

/**
 * @param {'MediaVideoId'| 'MediaImageId' | 'MediaDocumentId' | '*'} mediaType
 * @returns JSX.Element
 */
export const returnIconType = (mediaType) => {
  switch (mediaType) {
    case 'MediaVideoId':
      return <VideoLibrary style={{ color: '#004258', marginTop: '5px' }} />
    case 'MediaImageId':
      return <Image style={{ color: '#004258', marginTop: '5px' }} />
    case 'MediaDocumentId':
      return <Description style={{ color: '#004258', marginTop: '5px' }} />

    default:
      return <FilePresent style={{ color: '#F23030', marginTop: '5px' }} />
  }
}

/**
 * Returns the sign/symbol for text formatting based on the given type
 * @param {'BOLD' | 'ITALIC' | 'STRIKETHROUGH' | 'MONOSPACE'} type - The formatting type
 * @returns {string} The corresponding sign/symbol for the formatting type
 */
export const getSign = (type) => {
  const SIGN_FORMAT = {
    BOLD: '*',
    ITALIC: '_',
    STRIKETHROUGH: '~',
    MONOSPACE: '```',
  }

  return SIGN_FORMAT[type]
}
